import React from 'react';
import { gettext } from '@eb/i18n-ebspa';

import './OrganizerArticleCardImage.scss';

const OrganizerArticleCardImage = ({ image }) => (
    <div className="organizer-article-card__image-wrapper">
        <div className="organizer-article-card__image-container">
            <img
                className="organizer-article-card__image"
                src={image}
                alt={gettext('Organizer article image')}
            />
        </div>
    </div>
);

export default OrganizerArticleCardImage;
